const PARTNERS_CONTENT = [
  {
    title: "Apply",
    description:
      "Submit a short application outlining your background and audience.",
  },
  {
    title: "Review",
    description: "We’ll review and respond within 2 business days.",
  },
  {
    title: "Onboard",
    description:
      "Access your unique referral link and promotional resources.",
  },
  {
    title: "Promote & Earn",
    description:
      "Refer high-quality leads and receive monthly payouts.",
  },
];

export default PARTNERS_CONTENT;
